import styled from "styled-components"
import { mobile } from "../../Responsive"

export const Container = styled.div`
    background-color: ${({ theme }) => theme.body};
`

export const Wrapper = styled.div`
    min-height: 85vh;
`

export const Title = styled.h1`
    margin: 20px;

    ${mobile({ margin: "10px" })}
`

export const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
`